import { growthFormat } from '@intelligence/utils/commonUtils';

const ROBLOX_METRIC_RATIO_MAX_NUMBER = 99999;
const ROBLOX_RANK_CHANGE_MAX_NUMBER = 99999;

/** Roblox Top Charts 指标变化率（百分比） */
export const formatRobloxMetricRatioGrowth = (ratioValue?: number | null) =>
  growthFormat({
    value: ratioValue,
    valueType: 'pointValue',
    hasPoint: 'lessThanOne',
    fixedNum: 2,
    maxNumber: ROBLOX_METRIC_RATIO_MAX_NUMBER,
  });

/** 下载等纯文本场景：与表格 growthFormat 规则一致 */
export const formatRobloxMetricRatioText = (ratioValue?: number | null): string => {
  const growthData = formatRobloxMetricRatioGrowth(ratioValue);
  if (growthData?.value === '-' || growthData?.value === undefined || growthData?.value === null) {
    return '';
  }

  const valueText = String(growthData.value);
  return growthData.type === 'down' ? `-${valueText}` : valueText;
};

/** Roblox Game Rank 排名变化（位次 delta，非百分比） */
export const formatRobloxRankChangeGrowth = (rankDodValue?: number | null) =>
  growthFormat({
    value: rankDodValue,
    valueType: 'rankValue',
    hasPoint: 'none',
    fixedNum: 0,
    maxNumber: ROBLOX_RANK_CHANGE_MAX_NUMBER,
    zeroValue: '=',
  });

/** 下载等纯文本场景：与表格 growthFormat 规则一致 */
export const formatRobloxRankChangeText = (rankDodValue?: number | null): string => {
  const growthData = formatRobloxRankChangeGrowth(rankDodValue);
  if (growthData?.value === '-' || growthData?.value === undefined || growthData?.value === null) {
    return '';
  }

  return String(growthData.value);
};
